import { Capacitor } from '@capacitor/core';
import { Badge } from '@capawesome/capacitor-badge';

import { UnfinishedElementCount } from 'src/models/menu';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheCountOfAllUnfinishedItemsForTheUserQueryCallBack extends Callback<UnfinishedElementCount[]> {
	public constructor(
		private readonly setUnfinishedElementCountList: (payload: Array<UnfinishedElementCount>) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<UnfinishedElementCount>): void => {
		void Badge.isSupported().then((isSupported) => {
			if (isSupported && Capacitor.getPlatform() === 'ios') {
				const badgeCount = successResponse.reduce(
					(previousCount, currentItem) => previousCount + currentItem.count,
					0
				);

				void Badge.set({
					count: badgeCount,
				});
			}
		});

		this.setUnfinishedElementCountList(successResponse);
	};
}
